export { inputAutocompleteDirective } from './input-autocomplete-directive';
export { inputDurationDirective } from './input-duration-directive';
export { inputNumberDirective } from './input-number-directive';
export { inputTextDirective } from './input-text-directive';
export { inputColourDirective } from './input-colour-directive';
export { inputDateDirective } from './input-date-directive';
export { inputSelectDirective } from './input-select-directive';
export { inputChipsAutocompleteDirective } from './input-chips-autocomplete-directive';
export { inputTextareaDirective } from './input-textarea-directive';
export { inputPasswordConfirmationDirective } from './input-password-confirmation-directive';
export { inputCurrencyDirective } from './input-currency-directive';
export { inputCheckboxDirective } from './input-checkbox-directive';
export { inputEmailDirective } from './input-email-directive';
export { inputTimeDirective } from './input-time-directive';
export { inputPasswordDirective } from './input-password-directive';
export { datePickerDirective } from './date-picker/date-picker-directive';
export { inputDateSelectDirective } from './input-date-select-directive';
export { inputBooleanSelectDirective } from './boolean-select/input-boolean-select-directive';
export { inputSwitchDirective } from './input-switch-directive';
export { inputRateAdjustmentDirective } from './input-rate-adjustment-directive';
export { inputExtraPaymentsDirective } from './input-extra-payments-directive';
export { inputMultiEmailDirective } from './input-multi-email-directive';
export * from './when/input-when-directive';

/**
 * The md-select directive eats keydown events for some quick select logic.
 * Since we have a search input here, we don't need that logic.
 *
 * @param element
 * @param scope
 */
export function attachSelectSearch(element, scope) {
    const $el = element[0];
    let $input;

    // Check input exists

    const deregister = scope.$watch(
        () => findInput(),
        input => {
            $input = input;

            if (input) {
                onInputFound();
            }
        },
    );

    function onInputFound() {
        deregister();

        $input.addEventListener('keydown', event => {
            event.stopPropagation();
        });
    }

    function findInput() {
        return $el.querySelector('.app-form-select-search-container > input');
    }
}
